import { pxToRem } from '@withjoy/joykit/theme';

export const onboardingButtonOverrides = {
  Root: {
    props: {
      width: pxToRem(332),
      color: 'white',
      backgroundColor: '#4751F8',
      _hover: {
        backgroundSize: '200% 200%',
        backgroundImage:
          'radial-gradient(circle at var(--mouse-x, 0%) var(--mouse-y, 50%), color(display-p3 0.286275 0.317647 0.937255) 0%, color(display-p3 0.337255 0 0.95) 100%)'
      },
      _active: {
        color: 'white',
        backgroundColor: 'black'
      },
      _disabled: {
        color: 'mono8',
        backgroundColor: 'mono3'
      }
    }
  }
};
